import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@auth/data-access';

/**
 * Mirror of `requireLoginGuard`: block already-authenticated users from
 * landing on a sign-in/onboarding route and bounce them to the app's home.
 * Use this on kiosk/device sign-in screens where a back-navigation could
 * otherwise restart the pairing flow under an already-valid session.
 *
 * @example
 *   canActivate: [redirectIfLoggedInGuard('/')]
 */
export function redirectIfLoggedInGuard(redirectTo: string): CanActivateFn {
  return () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    return authStore.isLoggedIn() ? router.createUrlTree([redirectTo]) : true;
  };
}
